webpackJsonp([1],Array(23).concat([
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_notice__ = __webpack_require__(24);




var uuidV1 = __webpack_require__(290);
var state = {
  token: '',
  source: 5,
  uuid: sessionStorage.uuid || uuidV1(),
  version: '',
  language: 'zh_CN',
  device_name: '',
  corporation_id: ''
};
var instance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: "https://api.kuaipiyun.com/g1",
  timeout: 10000
});

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  var request_id = '5' + new Date().getTime().toString() + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["a" /* randomn */])(4);
  config.headers['kp-request-id'] = request_id;
  config.headers['kp-token'] = sessionStorage.token || '';
  config.headers['kp-source'] = state.source;
  config.headers['kp-uuid'] = state.uuid;
  config.headers['kp-version'] = state.version;
  config.headers['kp-language'] = state.language;
  config.headers['kp-device-name'] = state.device_name;
  config.headers['kp-corporation-id'] = state.corporation_id;
  sessionStorage.uuid = state.uuid;
  // localStorage.request_id = request_id
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

function responseHandler(response, options) {
  var data = response.data;
  if (data.code === 0) {
    options.success(data);
  } else if (data.code === 100000) {
    __WEBPACK_IMPORTED_MODULE_3__util_notice__["a" /* kpNotice */].warning('middle', 2000, '系统内部异常，请稍后再试');
  } else if (data.code === 100001) {
    __WEBPACK_IMPORTED_MODULE_3__util_notice__["a" /* kpNotice */].warning('middle', 2000, '系统升级中，请稍后再试');
  } else if (data.code === 100003) {
    // token过期
    window.location.href = '/';
  } else {
    // options.success(data)
    if (data.code === 150020) {
      options.success(data);
    } else {
      __WEBPACK_IMPORTED_MODULE_3__util_notice__["a" /* kpNotice */].warning('middle', 4000, data.msg + ',' + data.requestId);
      options.error(data);
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  config: function config(params) {
    // console.log('grpc的config设置', params)
    state.token = params.token || state.token;
    state.corporation_id = params.corporation_id || state.corporation_id;
  },


  instance: instance,

  call: function call(url, params) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      instance.post(url, params).then(function (response) {
        // kpNotice.warning('middle', 2000, '测试')
        // resolve(response.data)
        responseHandler(response, {
          success: function success(data) {
            resolve(data);
          },
          error: function error(data) {
            reject(data);
          }
        });
      }).catch(function (error) {
        // 此处要补充超时处理
        // kpNotice.warning('middle', 2000, '接口报错' + error)
        reject(error);
      });
    });
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return kpNotice; });
var kpNotice = {
  warning: function warning(position, time, text) {
    // console.log('this.$vux', window.vm.$vux, window.vm.$store)
    window.vm.$vux.toast.show({
      text: text,
      type: 'warn',
      width: '250px',
      position: position,
      time: time
    });
  }
};

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(251)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(301),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(270)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(320),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAllAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCountryList; });
/* unused harmony export getIndustry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSignature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return exchange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return downLoadLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getIndustry2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return exchange2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_request__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_notice__ = __webpack_require__(24);



function getAllAddress(params) {
  __WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */].call('/basic/all', params).then(function (response) {
    // console.log('获取全部省市区数据', response)
    if (response.code === 0) {
      params.callback(response);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, response.msg);
    }
  }).catch(function (error) {
    // console.log('获取全部省市区数据错误', error)
    params.errorback(error);
    __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, error);
  });
}
function getCountryList(params) {
  __WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */].call('/basic/country/list', params).then(function (response) {
    // console.log('获取全部国家数据', response)
    if (response.code === 0) {
      params.callback(response);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, response.msg);
    }
  }).catch(function (error) {
    // console.log('获取全部国家数据错误', error)
    params.errorback(error);
    __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, error);
  });
}

function getIndustry(params) {
  __WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */].call('/basic/industry/list', params).then(function (response) {
    // console.log('获取行业数据', response)
    if (response.code === 0) {
      params.callback(response);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, response.msg);
    }
  }).catch(function (error) {
    // console.log('获取行业数据错误', error)
    params.errorback(error);
    __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, error);
  });
}
function getSignature(params) {
  __WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */].call('/auth/agent/get/signature', params).then(function (response) {
    if (response.code === 0) {
      params.callback(response);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, response.msg);
    }
  }).catch(function (error) {
    __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, error);
  });
}
function exchange(params) {
  var request = {
    cityName: params.cityName,
    countyName: params.countyName,
    provinceName: params.provinceName
  };
  __WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */].call('/basic/exchange', request).then(function (response) {
    if (response.code === 0) {
      params.callback(response);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, response.msg);
    }
  }).catch(function (error) {
    __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, error);
  });
}
function downLoadLink(params) {
  var request = {
    platform: 1
  };
  __WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */].call('/basic/app_release/query/latest', request).then(function (response) {
    params.callback(response);
  });
}

function getIndustry2(params) {
  return __WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */].call('/basic/sys_industry/list', params);
}

function exchange2(params) {
  __WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */].call('/basic/exchange', params).then(function (response) {
    if (response.code === 0) {
      params.callback(response);
    } else {
      params.errorback && params.errorback(response.msg);
      __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, response.msg);
    }
  }).catch(function (error) {
    params.errorback && params.errorback(error);
    __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, error);
  });
}



/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return randomn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getImgUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return makeImgFileName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getImgFileReallyName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_defaultLogo_png__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_defaultLogo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_defaultLogo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_date__ = __webpack_require__(139);
// import { OSS_PATH } from '@/const/basic'



/**
 * @param 获取n位的数字随机数
 */
var randomn = function randomn(n) {
  if (n > 21) return null;
  return parseInt((Math.random() + 1) * Math.pow(10, n - 1));
};

var getImgUrl = function getImgUrl(path) {
  var appendStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!path) return __WEBPACK_IMPORTED_MODULE_0__assets_defaultLogo_png___default.a;else if (path.indexOf('http://') != -1 || path.indexOf('https://') != -1) {
    if (appendStr && path.indexOf('localhost') == -1) {
      return '' + path + appendStr;
    }
    return path;
  }
  return 'https://files.kuaipiyun.com/' + path + appendStr;
};

var makeImgFileName = function makeImgFileName(fileName, directoryName) {
  var directory = directoryName || 'agent';
  if (fileName) {
    return directory + '/' + fileName + '_' + __WEBPACK_IMPORTED_MODULE_1__util_date__["a" /* default */].format(new Date(), 'yyyy-MM-dd') + '-' + randomn(12);
  } else {
    return '';
  }
};

var getImgFileReallyName = function getImgFileReallyName(fileName) {
  if (fileName && fileName.indexOf('_') > -1) {
    if (fileName.split('_')[0].indexOf('/') > -1) {
      return fileName.split('_')[0].split('/')[1];
    } else {
      return fileName;
    }
  } else {
    return fileName;
  }
};

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(280)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(330),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(267)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(317),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(248)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(298),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return corpList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return registCorp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_request__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_notice__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(39);




function corpList(params) {
  var request = {
    phone: sessionStorage.accountPhone,
    email: sessionStorage.accountEmail
  };
  __WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */].call('/corp/corporation/invite/register/query', request).then(function (response) {
    if (response.code === 0) {
      params.callback(response);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, response.code + response.msg + response.requestId);
    }
  }).catch(function (error) {
    params.errorback(error);
    __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, error);
  });
}
function registCorp(params) {
  var request = {
    clueId: params.clueId,
    assignedAgentId: localStorage.agentId,
    cityId: params.cityId,
    corpAddress: params.corpAddress,
    corpAdminName: params.corpAdminName,
    corpName: params.corpName,
    corpRegisterOrigin: 2,
    corpType: params.corpType,
    countryId: params.countryId,
    creatorAgentId: localStorage.agentId,
    currencyId: 'CNY',
    districtId: params.districtId,
    email: params.email,
    followAgentStaffId: localStorage.getASIByUrl,
    industry1Id: params.industry1Id,
    industry2Id: params.industry2Id,
    phone: params.phone,
    provinceId: params.provinceId,
    sellerAgentStaffId: localStorage.getASIByUrl,
    sysSequence: new Date().getTime().toString() + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["a" /* randomn */])(6),
    timeZoneId: 'Asia/Shanghai',
    storeImages: params.storeImages,
    mainIndustryId: params.mainIndustryId,
    secondIndustryId1: params.secondIndustryId1 || '',
    secondIndustryId2: params.secondIndustryId2 || '',
    corpVersion1: params.corpVersion1,
    corpPlugin: params.corpPlugin
  };
  __WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */].call('/third/corporation/register', request).then(function (response) {
    if (response.code === 0) {
      params.callback(response);
    } else {
      console.log('corp.js error:' + response.code);
      params.errorback(response);
      __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 5000, response.code + response.msg + response.requestId);
    }
  }).catch(function (error) {
    console.log('corp.js catch error:');
    params.errorback(error);
    __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 5000, error.msg + '(' + error.requestId + ')');
  });
}



/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(255)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(305),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(257)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(307),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(268)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(318),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(260)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(310),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(272)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(322),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(258)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(308),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(263)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(313),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(250)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(300),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(261)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(311),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4acae14a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports) {

!function (a, b) {
  function c() {
    var b = f.getBoundingClientRect().width;b / i > 540 && (b = 540 * i);var c = b / 10;f.style.fontSize = c + "px", k.rem = a.rem = c;
  }var d,
      e = a.document,
      f = e.documentElement,
      g = e.querySelector('meta[name="viewport"]'),
      h = e.querySelector('meta[name="flexible"]'),
      i = 0,
      j = 0,
      k = b.flexible || (b.flexible = {});if (g) {
    console.warn("将根据已有的meta标签来设置缩放比例");var l = g.getAttribute("content").match(/initial\-scale=([\d\.]+)/);l && (j = parseFloat(l[1]), i = parseInt(1 / j));
  } else if (h) {
    var m = h.getAttribute("content");if (m) {
      var n = m.match(/initial\-dpr=([\d\.]+)/),
          o = m.match(/maximum\-dpr=([\d\.]+)/);n && (i = parseFloat(n[1]), j = parseFloat((1 / i).toFixed(2))), o && (i = parseFloat(o[1]), j = parseFloat((1 / i).toFixed(2)));
    }
  }if (!i && !j) {
    var p = (a.navigator.appVersion.match(/android/gi), a.navigator.appVersion.match(/iphone/gi)),
        q = a.devicePixelRatio;i = p ? q >= 3 && (!i || i >= 3) ? 3 : q >= 2 && (!i || i >= 2) ? 2 : 1 : 1, j = 1 / i;
  }if (f.setAttribute("data-dpr", i), !g) if (g = e.createElement("meta"), g.setAttribute("name", "viewport"), g.setAttribute("content", "initial-scale=" + j + ", maximum-scale=" + j + ", minimum-scale=" + j + ", user-scalable=no"), f.firstElementChild) f.firstElementChild.appendChild(g);else {
    var r = e.createElement("div");r.appendChild(g), e.write(r.innerHTML);
  }a.addEventListener("resize", function () {
    clearTimeout(d), d = setTimeout(c, 300);
  }, !1), a.addEventListener("pageshow", function (a) {
    a.persisted && (clearTimeout(d), d = setTimeout(c, 300));
  }, !1), "complete" === e.readyState ? e.body.style.fontSize = 12 * i + "px" : e.addEventListener("DOMContentLoaded", function () {
    e.body.style.fontSize = 12 * i + "px";
  }, !1), c(), k.dpr = a.dpr = i, k.refreshRem = c, k.rem2px = function (a) {
    var b = parseFloat(a) * this.rem;return "string" == typeof a && a.match(/rem$/) && (b += "px"), b;
  }, k.px2rem = function (a) {
    var b = parseFloat(a) / this.rem;return "string" == typeof a && a.match(/px$/) && (b += "rem"), b;
  };
}(window, window.lib || (window.lib = {}));

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_corpList__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_corpList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_corpList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_login__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_register__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_downLoad__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_downLoad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_downLoad__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]({
  routes: [{
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_login___default.a
  }, {
    path: '/corpList',
    component: __WEBPACK_IMPORTED_MODULE_2__components_corpList___default.a
  }, {
    path: '/register',
    component: __WEBPACK_IMPORTED_MODULE_4__components_register___default.a
  }, {
    path: '/downLoad',
    component: __WEBPACK_IMPORTED_MODULE_5__components_downLoad___default.a
  }]
}));

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(61);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  modules: {},
  strict: "production" !== 'production'
}));

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(275)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(324),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sendEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return bind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUserdata; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_request__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_notice__ = __webpack_require__(24);



function sendMessage(params) {
  var request = {
    phone: params.phone,
    type: 4
  };
  __WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */].call('/auth/notify/sms', request).then(function (response) {
    if (response.code === 0) {
      params.callback(response);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, response.code + response.msg + response.requestId);
    }
  }).catch(function (error) {
    params.errorback(error);
    __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, error);
  });
}
function sendEmail(params) {
  var request = {
    email: params.email,
    type: 4
  };
  __WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */].call('/auth/notify/email', request).then(function (response) {
    if (response.code === 0) {
      params.callback(response);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, response.code + response.msg + response.requestId);
    }
  }).catch(function (error) {
    params.errorback(error);
    __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, error);
  });
}
function bind(params) {
  var request = {
    code: params.code,
    data: params.data,
    openId: sessionStorage.openId || null,
    type: params.type
  };
  __WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */].call('/auth/agent/invite/bindWx', request).then(function (response) {
    if (response.code === 0) {
      params.callback(response);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, response.code + response.msg + response.requestId);
    }
  }).catch(function (error) {
    params.errorback(error);
    __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, error);
  });
}
function getUserdata(params) {
  var request = {
    agentStaffId: params.agentStaffId
  };
  __WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */].call('/agent/agent/staff/part_info', request).then(function (response) {
    if (response.code === 0) {
      params.callback(response);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__util_notice__["a" /* kpNotice */].warning('middle', 2000, response.code + response.msg + response.requestId);
    }
  });
}


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_normalize_css__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_i18n__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fastclick__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_js_flexible_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_js_flexible_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modules_js_flexible_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_plugins_toast_index_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_plugins_confirm_index_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_plugins_wechat_index_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vux_src_plugins_alert_index_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vux_src_plugins_loading_index_js__ = __webpack_require__(112);










__WEBPACK_IMPORTED_MODULE_6_fastclick___default.a.attach(document.body);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_i18n__["default"]);

var VueUploadComponent = __webpack_require__(117);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vux_src_plugins_toast_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vux_src_plugins_confirm_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vux_src_plugins_wechat_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vux_src_plugins_alert_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vux_src_plugins_loading_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('file-upload', VueUploadComponent);

var i18n = new __WEBPACK_IMPORTED_MODULE_5_vue_i18n__["default"]({
  locale: 'zh-cn'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    holdEmoji: function holdEmoji(value) {
      if (typeof value !== 'string') {
        return value;
      }
      var reg = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F\uDE80-\uDEFF]/g;
      return value.replace(reg, '');
    }
  },
  computed: {
    isWx: function isWx() {
      var ua = window.navigator.userAgent;
      return ua.toLowerCase().indexOf('micromessenger') !== -1;
    }
  }
});

/* eslint-disable no-new */
top.vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  i18n: i18n,
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  format: function format(date, fmt) {
    date *= 1;
    if (!date || date === '0') {
      return '';
    }
    date = new Date(date);
    var options = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var o in options) {
      if (new RegExp('(' + o + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? options[o] : ('00' + options[o]).substr(('' + options[o]).length));
      }
    }
    return fmt;
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'actionsheet',
  mounted: function mounted() {
    var _this = this;

    this.hasHeaderSlot = !!this.$slots.header;
    this.$nextTick(function () {
      _this.$tabbar = document.querySelector('.weui-tabbar');
      _this.$refs.iOSMenu && _this.$refs.iOSMenu.addEventListener('transitionend', _this.onTransitionEnd);
    });
  },

  props: {
    value: Boolean,
    showCancel: Boolean,
    cancelText: String,
    theme: {
      type: String,
      default: 'ios'
    },
    menus: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    closeOnClickingMask: {
      type: Boolean,
      default: true
    },
    closeOnClickingMenu: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasHeaderSlot: false,
      show: false
    };
  },

  methods: {
    onTransitionEnd: function onTransitionEnd() {
      this.$emit(this.show ? 'on-after-show' : 'on-after-hide');
    },
    onMenuClick: function onMenuClick(text, key) {
      if (typeof text === 'string') {
        this.emitEvent('on-click-menu', key, text);
      } else {
        if (text.type !== 'disabled' && text.type !== 'info') {
          if (text.value || text.value === 0) {
            this.emitEvent('on-click-menu', text.value, text);
          } else {
            this.emitEvent('on-click-menu', '', text);
            this.show = false;
          }
        }
      }
    },
    onClickingMask: function onClickingMask() {
      this.$emit('on-click-mask');
      this.closeOnClickingMask && (this.show = false);
    },
    emitEvent: function emitEvent(event, menu, item) {
      if (event === 'on-click-menu' && !/.noop/.test(menu)) {
        var _item = item;
        if ((typeof _item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_item)) === 'object') {
          _item = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_item));
        }
        this.$emit(event, menu, _item);
        this.$emit(event + '-' + menu);
        this.closeOnClickingMenu && (this.show = false);
      }
    },
    fixIos: function fixIos(zIndex) {
      if (this.$el.parentNode && this.$el.parentNode.className.indexOf('v-transfer-dom') !== -1) {
        return;
      }
      if (this.$tabbar && /iphone/i.test(navigator.userAgent)) {
        this.$tabbar.style.zIndex = zIndex;
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this2 = this;

      this.$emit('input', val);
      if (val) {
        this.fixIos(-1);
      } else {
        setTimeout(function () {
          _this2.fixIos(100);
        }, 200);
      }
    },

    value: {
      handler: function handler(val) {
        this.show = val;
      },
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.fixIos(100);
    this.$refs.iOSMenu && this.$refs.iOSMenu.removeEventListener('transitionend', this.onTransitionEnd);
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'alert',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_router__ = __webpack_require__(41);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cell-box',
  props: {
    isLink: Boolean,
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    },
    noFlex: Boolean,
    alignItems: String
  },
  computed: {
    style: function style() {
      if (this.alignItems) {
        return {
          'align-items': this.alignItems
        };
      }
    },
    className: function className() {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui-cell_access': this.isLink || !!this.link,
        'vux-cell-no-border-intent': !this.borderIntent
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.link && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__libs_router__["a" /* go */])(this.link, this.$router);
    }
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__props__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_clean_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_get_parent_prop__ = __webpack_require__(187);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cell',
  components: {
    InlineDesc: __WEBPACK_IMPORTED_MODULE_0__inline_desc___default.a
  },
  props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__props__["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__libs_clean_style__["a" /* default */])({
        width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__libs_get_parent_prop__["a" /* default */])(this, 'labelWidth'),
        textAlign: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__libs_get_parent_prop__["a" /* default */])(this, 'labelAlign'),
        marginRight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__libs_get_parent_prop__["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_router__["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.value) === 'object' && isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(one);
          }).indexOf(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
});

function isEqual(obj1, obj2) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj1) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj2);
}

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirm',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datetimepicker__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__group__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inline_desc__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_uuid__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tools_date_format__ = __webpack_require__(194);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'datetime',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_uuid__["a" /* default */]],
  components: {
    Group: __WEBPACK_IMPORTED_MODULE_3__group___default.a,
    InlineDesc: __WEBPACK_IMPORTED_MODULE_4__inline_desc___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_1__icon___default.a
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new __WEBPACK_IMPORTED_MODULE_2__datetimepicker__["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tools_date_format__["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'divider'
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_clean_style__ = __webpack_require__(75);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'group',
  methods: {
    cleanStyle: __WEBPACK_IMPORTED_MODULE_0__libs_clean_style__["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'inline-desc'
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_router__ = __webpack_require__(41);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'panel',
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    onImgError: function onImgError(item, $event) {
      this.$emit('on-img-error', JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item)), $event);
      if (item.fallbackSrc) {
        $event.target.src = item.fallbackSrc;
      }
    },
    getUrl: function getUrl(url) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_router__["b" /* getUrl */])(url, this.$router);
    },
    onClickFooter: function onClickFooter() {
      this.$emit('on-click-footer');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_router__["a" /* go */])(this.footer.url, this.$router);
    },
    onClickHeader: function onClickHeader() {
      this.$emit('on-click-header');
    },
    onItemClick: function onItemClick(item) {
      this.$emit('on-click-item', item);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_router__["a" /* go */])(item.url, this.$router);
    }
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scroller__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flexbox__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chain__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filters_value2name__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_is_array__ = __webpack_require__(188);


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'picker',
  components: {
    Flexbox: __WEBPACK_IMPORTED_MODULE_3__flexbox__["a" /* Flexbox */],
    FlexboxItem: __WEBPACK_IMPORTED_MODULE_3__flexbox__["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new __WEBPACK_IMPORTED_MODULE_4__chain__["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__filters_value2name__["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new __WEBPACK_IMPORTED_MODULE_2__scroller__["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new __WEBPACK_IMPORTED_MODULE_2__scroller__["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.getValue()) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new __WEBPACK_IMPORTED_MODULE_4__chain__["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__picker__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cell__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popup__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popup_header__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popup_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__popup_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inline_desc__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flexbox__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filters_array2String__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters_value2name__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_mixin_uuid__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_transfer_dom__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var getObject = function getObject(obj) {
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'popup-picker',
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_10__directives_transfer_dom__["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9__libs_mixin_uuid__["a" /* default */]],
  components: {
    Picker: __WEBPACK_IMPORTED_MODULE_1__picker___default.a,
    Cell: __WEBPACK_IMPORTED_MODULE_2__cell___default.a,
    Popup: __WEBPACK_IMPORTED_MODULE_3__popup___default.a,
    PopupHeader: __WEBPACK_IMPORTED_MODULE_4__popup_header___default.a,
    Flexbox: __WEBPACK_IMPORTED_MODULE_6__flexbox__["a" /* Flexbox */],
    FlexboxItem: __WEBPACK_IMPORTED_MODULE_6__flexbox__["b" /* FlexboxItem */],
    InlineDesc: __WEBPACK_IMPORTED_MODULE_5__inline_desc___default.a
  },
  filters: {
    array2string: __WEBPACK_IMPORTED_MODULE_7__filters_array2String__["a" /* default */],
    value2name: __WEBPACK_IMPORTED_MODULE_8__filters_value2name__["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: __WEBPACK_IMPORTED_MODULE_8__filters_value2name__["a" /* default */],
    getNameValues: function getNameValues() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filters_value2name__["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentValue) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = getObject(val);
      this.$emit('on-shadow-change', _val, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filters_value2name__["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tempValue)) {
        this.tempValue = getObject(val);
        this.currentValue = getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', getObject(val));
      this.$emit('on-change', getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: getObject(this.value),
      closeType: false,
      currentData: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popup__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_dom__ = __webpack_require__(76);

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new __WEBPACK_IMPORTED_MODULE_1__popup__["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && __WEBPACK_IMPORTED_MODULE_2__libs_dom__["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && __WEBPACK_IMPORTED_MODULE_2__libs_dom__["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_x_photoswipe_dist_photoswipe__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_x_photoswipe_dist_photoswipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_x_photoswipe_dist_photoswipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_x_photoswipe_dist_photoswipe_ui_default__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_x_photoswipe_dist_photoswipe_ui_default___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_x_photoswipe_dist_photoswipe_ui_default__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_object_assign__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = __WEBPACK_IMPORTED_MODULE_2_object_assign___default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new __WEBPACK_IMPORTED_MODULE_0_x_photoswipe_dist_photoswipe___default.a(this.$el, __WEBPACK_IMPORTED_MODULE_1_x_photoswipe_dist_photoswipe_ui_default___default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
        _this.photoswipe = null;
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      if (this.photoswipe) {
        return this.photoswipe.getCurrentIndex();
      }
    },
    close: function close() {
      this.photoswipe && this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe && this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe && this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe && this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__ = __webpack_require__(190);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toast',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters_name2value__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filters_value2name__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popup_picker__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popup_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__popup_picker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-address',
  components: {
    PopupPicker: __WEBPACK_IMPORTED_MODULE_2__popup_picker___default.a
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columns: {
      type: Number,
      default: function _default() {
        return 3;
      }
    },
    rawValue: Boolean,
    list: {
      type: Array,
      required: true
    },
    labelWidth: String,
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String,
    confirmText: String,
    cancelText: String,
    displayFormat: {
      type: Function,
      default: function _default(val, names) {
        return names;
      }
    },
    popupStyle: Object,
    popupTitle: String,
    show: Boolean,
    disabled: Boolean
  },
  created: function created() {
    if (this.currentValue.length && this.rawValue) {
      var parsedVal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__filters_name2value__["a" /* default */])(this.currentValue, this.list);
      if (/__/.test(parsedVal)) {
        console.error('[VUX] Wrong address value', this.currentValue);
        this.currentValue = [];
      } else {
        this.currentValue = parsedVal.split(' ');
      }
    }
    if (this.show) {
      this.showValue = true;
    }
  },

  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__filters_value2name__["a" /* default */])(this.value, this.list);
    },
    onShadowChange: function onShadowChange(ids, names) {
      this.$emit('on-shadow-change', ids, names);
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      showValue: false
    };
  },

  computed: {
    nameValue: function nameValue() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__filters_value2name__["a" /* default */])(this.currentValue, this.list);
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (val.length && !/\d+/.test(val[0])) {
        var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__filters_name2value__["a" /* default */])(val, this.list).split(' ');
        if (id[0] !== '__' && id[1] !== '__') {
          this.currentValue = id;
          return;
        }
      }
      this.currentValue = val;
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__ = __webpack_require__(189);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_base__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toast__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inline_desc__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_validator_lib_isMobilePhone__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_validator_lib_isMobilePhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_validator_lib_isMobilePhone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tools_debounce__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vanilla_masker__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vanilla_masker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vanilla_masker__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: __WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail___default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return __WEBPACK_IMPORTED_MODULE_6_validator_lib_isMobilePhone___default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tools_debounce__["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__libs_base__["a" /* default */]],
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2__icon___default.a,
    InlineDesc: __WEBPACK_IMPORTED_MODULE_4__inline_desc___default.a,
    Toast: __WEBPACK_IMPORTED_MODULE_3__toast___default.a
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? __WEBPACK_IMPORTED_MODULE_8_vanilla_masker___default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_request__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controller_basic__ = __webpack_require__(38);

//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      appId: 'wx007c0d3fb6f94ab0',
      linkUrl: 'https://event.kuaipiyun.com/',
      transitionName: '',
      loading: true,
      loaindgText: '',
      path: '/',
      // 当前登录账号的coropration
      loginCoropration: {},
      getCorpration: false,
      wxloginLink: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx007c0d3fb6f94ab0&redirect_uri=' + encodeURIComponent('https://event.kuaipiyun.com/') + '&response_type=code&scope=snsapi_userinfo&state=1234#wechat_redirect',
      wxloginLinkTest: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx390e7cd501e61f98&redirect_uri=' + encodeURIComponent('https://event.kuaipitest.com') + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect',
      isDoneWxShare: false
      // wxloginLink: '?code=081ivnXi12xl9v0PBDVi1B25Xi1ivnX9&state=agent123'
    };
  },
  created: function created() {
    if (!this.isWx) {
      return;
    }
    if (window.location.href.includes('kuaipitest')) {
      this.appId = 'wx390e7cd501e61f98';
      this.linkUrl = 'https://event.kuaipitest.com';
    }
    var includeCode = window.location.href.includes('?code=');
    if (!includeCode) {
      var clueId = this.$route.query.clueId;
      if (clueId) {
        localStorage.getASIByUrl = this.$route.query.agentStaffId;
        localStorage.agentId = this.$route.query.agentId;
        localStorage.clueId = clueId;
        localStorage.mainIndustryId = this.$route.query.mainIndustryId;
        localStorage.corpVersion1 = this.$route.query.corpVersion1;
        localStorage.corpPlugin = this.$route.query.corpPlugin;
      }
      if (window.location.href.includes('kuaipitest')) {
        window.location.href = this.wxloginLinkTest;
      } else {
        window.location.href = this.wxloginLink;
      }
    } else {
      this.wxShare();
      this.getAppId();
    }
  },
  mounted: function mounted() {},

  methods: {
    getAppId: function getAppId() {
      var _this = this;

      if (!sessionStorage.token) {
        // 微信授权登陆后链接重定向，检测路径中是否包含code值
        if (window.location.href.includes('localhost')) {
          // 线下环境模拟转跳code地址,正常在mounted钩子完成
          // 在此处替换线下手动获取的code值
          this.wxloginLink = '?code=061nSA7E1Nuvu60GAb9E1CjD7E1nSA77&state=agent123';
          this.$router.push({ path: this.wxloginLink });
        } else {
          // 访问valid接口
          var getcode = window.location.href.split('?code=')[1].split('&state')[0] || '';
          var getappId = window.location.href.includes('localhost') ? 'wx9fd51801e57d0c4d' : window.location.href.includes('kuaipitest') ? 'wx390e7cd501e61f98' : 'wx007c0d3fb6f94ab0';
          __WEBPACK_IMPORTED_MODULE_1__api_request__["a" /* default */].call('/auth/agent/invite/register/validate', {
            // 此处要区分线上线下不同的appid,线上appid:wx007c0d3fb6f94ab0,线下：6.0admin的appid:wx9fd51801e57d0c4d
            appId: getappId,
            code: getcode,
            agentStaffId: localStorage.getASIByUrl
          }).then(function (response) {
            if (response.code === 0) {
              if (response.data.type === 1) {
                sessionStorage.setItem('openId', response.data.openId);
                sessionStorage.setItem('token', response.data.token);
                localStorage.agentType = response.data.agentType;
                // 转跳到绑定手机邮箱的页面
                _this.$router.push({
                  path: '/login'
                });
              } else if (response.data.type === 2) {
                // 已经绑定过的微信账号，进行登陆
                sessionStorage.setItem('openId', response.data.openId);
                sessionStorage.setItem('token', response.data.token);
                sessionStorage.setItem('accountEmail', response.data.accountEmail);
                sessionStorage.setItem('accountPhone', response.data.accountPhone);
                if (response.data.apiUrl) {
                  localStorage.apiUrl = response.data.apiUrl;
                  var urlArr = response.data.staticUrl.match(/^http[s]{0,1}:\/\/(.*?)(\/.*?)\//);
                  var after = urlArr[2] || '';
                  location.href = '' + window.location.origin + after + '/';
                  return;
                }
                // 设置临时token
                __WEBPACK_IMPORTED_MODULE_1__api_request__["a" /* default */].config({
                  token: response.data.token
                });
                _this.$router.push({ path: '/corpList' });
              }
            } else {
              _this.$vux.toast.show({
                text: response.code + ',' + response.msg + ',' + response.requestId,
                type: 'warn',
                width: '200px',
                position: 'middle',
                time: 2000
              });
            }
          }).catch(function (error) {
            _this.$vux.toast.show({
              text: '验证接口报错' + error,
              type: 'warn',
              width: '200px',
              position: 'middle',
              time: 2000
            });
          });
        }
      } else {
        // 有token的情况下，直接进入corplist.vue企业列表页面
        // 考虑staffDetail的时效性，关闭网页是否清空
        if (localStorage.apiUrl) {
          __WEBPACK_IMPORTED_MODULE_1__api_request__["a" /* default */].instance.defaults.baseURL = localStorage.apiUrl;
        }
        __WEBPACK_IMPORTED_MODULE_1__api_request__["a" /* default */].config({
          token: sessionStorage.token
        });
        this.$router.push({ path: '/corpList' });
      }
    },
    wxShare: function wxShare() {
      var _this2 = this;

      var wxdata = {
        config: {
          appId: this.appId,
          timestamp: parseInt(new Date().getTime() / 1000),
          nonceStr: Math.random().toString(36).substr(2),
          signature: '',
          jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'openAddress'],
          url: window.location.href.split('#')[0]
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__controller_basic__["a" /* getSignature */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, wxdata.config, {
        callback: function callback(response) {
          wxdata.config.signature = response.data;
          var timer = setInterval(function () {
            if (wxdata.config.signature) {
              wx.config(wxdata.config);
              wx.ready(function () {
                wx.onMenuShareAppMessage({
                  title: '邀请你使用快批', // 分享标题
                  desc: '用快批极速开单，轻松管店',
                  link: _this2.linkUrl + '#/?agentStaffId=' + localStorage.getASIByUrl + '&agentId=' + localStorage.agentId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: 'https://kp7files.oss-cn-shanghai.aliyuncs.com/1/ab57c441-6d27-43a5-92ad-bf5a1891f747.png', // 分享图标
                  success: function success() {}
                });
                wx.onMenuShareTimeline({
                  title: '邀请你使用快批', // 分享标题
                  link: _this2.linkUrl + '#/?agentStaffId=' + localStorage.getASIByUrl + '&agentId=' + localStorage.agentId,
                  imgUrl: 'https://kp7files.oss-cn-shanghai.aliyuncs.com/1/ab57c441-6d27-43a5-92ad-bf5a1891f747.png', // 分享图标
                  success: function success() {}
                });
              });
              clearInterval(timer);
            } else {
              wxdata.config.signature = response.data;
            }
          }, 200);
        }
      }));
    }
  },
  watch: {
    '$store.state.session.timeout': function $storeStateSessionTimeout(val) {
      if (val) {
        clearInterval(this.timer);
      }
    },
    '$route': function $route(to, from) {
      // IOS系统的分享，初始化需要在路径初始化的时候就设置config
      if (to.path === '/') {
        // next()
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          this.wxShare();
        }
      }
    }
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugin_bottombtn__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugin_bottombtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__plugin_bottombtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_cell_index_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_cell_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_cell_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_panel_index_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_panel_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_panel_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_confirm_index_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_confirm_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_confirm_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_cell_box_index_vue__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_cell_box_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_cell_box_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__controller_corp__ = __webpack_require__(72);











/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      account: {
        phone: '',
        email: ''
      },
      corpList: [],
      isContinue: true
    };
  },
  created: function created() {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__controller_corp__["b" /* corpList */])({
      callback: function callback(res) {
        _this.corpList = res.data;
        if (!res.data) {
          _this.$router.push('/register');
        }
      }
    });
  },

  methods: {},
  components: {
    KpBottomBtn: __WEBPACK_IMPORTED_MODULE_0__plugin_bottombtn___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default.a,
    Cell: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_cell_index_vue___default.a,
    Panel: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_panel_index_vue___default.a,
    Confirm: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_confirm_index_vue___default.a,
    CellBox: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_cell_box_index_vue___default.a
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controller_basic__ = __webpack_require__(38);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'downLoad',
  data: function data() {
    return {
      link: ''
    };
  },
  mounted: function mounted() {
    this.getLink();
  },

  computed: {
    isWx: function isWx() {
      var ua = window.navigator.userAgent;
      return ua.toLowerCase().indexOf('micromessenger') !== -1;
    }
  },
  methods: {
    clickLink: function clickLink(e) {
      if (navigator.userAgent.match(/android/i)) {
        if (this.isWx) {
          e.preventDefault();
          this.$vux.alert.show({
            content: '\u8BF7\u70B9\u51FB\u53F3\u4E0A\u89D2\u201C...\u201D<br/>\u5E76\u9009\u62E9\u6253\u5F00\u6D4F\u89C8\u5668\u8FDB\u884C\u4E0B\u8F7D'
          });
        }
      } else {
        e.preventDefault();
        window.open('https://itunes.apple.com/cn/app//id1450803780?mt=8');
      }
    },

    // 获取app下载地址
    getLink: function getLink() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__controller_basic__["b" /* downLoadLink */])({
        callback: function callback(res) {
          _this.link = res.data.releaseUrl;
        }
      });
    }
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controller_login__ = __webpack_require__(137);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      inviterAvatar: null,
      loading: true,
      count: 60,
      accountType: null,
      agentStaffName: '',
      agentStaffAvatar: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    // 这里目前做成浏览器进来不查邀请人
    if (!this.isWx) {
      return;
    }
    // 获取邀请人信息
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__controller_login__["a" /* getUserdata */])({
      agentStaffId: localStorage.getASIByUrl || this.$route.query.staffId,
      callback: function callback(res) {
        _this.agentStaffName = res.data.agentStaffName;
        _this.agentStaffAvatar = res.data.agentStaffAvatar;
        localStorage.agentType = res.data.agentType;
      },
      errorback: function errorback() {
        _this.$vux.toast.show({
          text: '获取用户信息失败',
          type: 'cancel',
          width: '200px'
        });
      }
    });
  },

  methods: {
    limitcontent: function limitcontent() {
      // 不能输入中文
      this.$refs.username.value = this.$refs.username.value.replace(/[\u4e00-\u9fa5]/g, '');
    },
    countDown: function countDown() {
      if (this.count > 0) {
        this.$refs.passwordbtn.disabled = 'disabled';
        this.$refs.passwordbtn.classList.add('click');
        this.$refs.passwordbtn.value = '重新获取验证码(' + this.count + ')';
        this.count--;
        setTimeout(this.countDown, 1000);
      } else {
        this.$refs.passwordbtn.removeAttribute('disabled');
        this.$refs.passwordbtn.classList.remove('click');
        this.$refs.passwordbtn.value = '获取验证码';
        this.count = 60;
      }
    },
    getcode: function getcode() {
      var _this2 = this;

      // 点击获取验证码的时候，将所有错误提示和原先填写的验证码给清除
      this.$refs.verificate.innerText = '';
      if (/.+@.+\.[a-zA-Z]{2,4}$/.test(this.$refs.username.value) || /^1\d{10}$/.test(this.$refs.username.value)) {
        this.countDown();
        if (this.$refs.username.value.indexOf('@') === -1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__controller_login__["b" /* sendMessage */])({
            phone: this.$refs.username.value,
            callback: function callback(response) {
              _this2.loading = false;
              if (!response.code) {
                _this2.$refs.verificate.style.color = '#757575';
                _this2.$refs.verificate.innerText = '短信验证码发送成功';
              } else {
                _this2.$refs.verificate.style.color = '#ec2020';
                _this2.$refs.verificate.innerText = '短信验证码发送失败,请重新点击获取';
              }
            },
            errorback: function errorback() {
              _this2.loading = false;
              _this2.$refs.verificate.style.color = '#ec2020';
              _this2.$refs.verificate.innerText = '短信验证码发送失败,请重新点击获取';
            }
          });
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__controller_login__["c" /* sendEmail */])({
            email: this.$refs.username.value,
            callback: function callback(response) {
              _this2.loading = false;
              if (!response.code) {
                _this2.$refs.verificate.style.color = '#757575';
                _this2.$refs.verificate.innerText = '邮箱验证码发送成功';
              } else {
                _this2.$refs.verificate.style.color = '#ec2020';
                _this2.$refs.verificate.innerText = '邮箱验证码发送失败,请重新点击获取';
              }
            },
            errorback: function errorback() {
              _this2.loading = false;
              _this2.$refs.verificate.style.color = '#ec2020';
              _this2.$refs.verificate.innerText = '邮箱验证码发送失败,请重新点击获取';
            }
          });
        }
      } else if (this.$refs.username.value === '') {
        this.$refs.verificate.style.color = '#ec2020';
        this.$refs.verificate.innerText = '手机号码或邮箱不能为空';
      } else {
        this.$refs.verificate.style.color = '#ec2020';
        this.$refs.verificate.innerText = '手机号码或邮箱格式错误';
      }
    },
    submit: function submit() {
      var _this3 = this;

      if (!this.$refs.username.value) {
        this.$refs.verificate.style.color = '#ec2020';
        this.$refs.verificate.innerText = '请输入手机号码/邮箱';
      } else if (!this.$refs.password.value) {
        this.$refs.verificate.style.color = '#ec2020';
        this.$refs.verificate.innerText = '请输入验证码';
      } else if (this.$refs.password.value.length !== 4) {
        this.$refs.verificate.style.color = '#ec2020';
        this.$refs.verificate.innerText = '验证码长度为4位';
      } else {
        if (~this.$refs.username.value.indexOf('@')) {
          this.accountType = 2;
        } else {
          this.accountType = 1;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__controller_login__["d" /* bind */])({
          code: this.$refs.password.value,
          data: this.$refs.username.value,
          type: this.accountType,
          callback: function callback(res) {
            if (~_this3.$refs.username.value.indexOf('@')) {
              sessionStorage.accountEmail = _this3.$refs.username.value;
            } else {
              sessionStorage.accountPhone = _this3.$refs.username.value;
            }
            if (res.data.token) {
              sessionStorage.setItem('token', res.data.token);
            }
            if (res.data.apiUrl) {
              localStorage.apiUrl = res.data.apiUrl;
              var urlArr = res.data.staticUrl.match(/^http[s]{0,1}:\/\/(.*?)(\/.*?)\//);
              var after = urlArr[2] || '';
              location.href = '' + window.location.origin + after + '/';
              return;
            }
            _this3.$router.push('/corpList');
          },
          errorback: function errorback() {
            _this3.$vux.toast.show({
              text: '绑定失败',
              type: 'cancel',
              width: '200px'
            });
          }
        });
      }
    }
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugin_bottombtn__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugin_bottombtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__plugin_bottombtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__controller_corp__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__controller_basic__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugin_Position__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugin_Position___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__plugin_Position__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugin_KpFileUpload__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugin_KpFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__plugin_KpFileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugin_industry_checker__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugin_industry_checker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__plugin_industry_checker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_x_input_index_vue__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_x_input_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vux_src_components_x_input_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vux_src_components_x_address_index_vue__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vux_src_components_x_address_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vux_src_components_x_address_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vux_src_components_group_index_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vux_src_components_x_header_index_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vux_src_components_cell_index_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vux_src_components_cell_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vux_src_components_cell_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vux_src_components_datetime_index_vue__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vux_src_components_datetime_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vux_src_components_datetime_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vux_src_components_popup_picker_index_vue__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vux_src_components_popup_picker_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vux_src_components_popup_picker_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vux_src_components_actionsheet_index_vue__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vux_src_components_actionsheet_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vux_src_components_actionsheet_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vux_src_components_picker_index_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vux_src_components_picker_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vux_src_components_picker_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vux_src_components_divider_index_vue__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vux_src_components_divider_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vux_src_components_divider_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vux_src_components_toast_index_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vux_src_components_toast_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vux_src_components_toast_index_vue__);

























var mailreg = /.+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'addcustomer',
  components: {
    XInput: __WEBPACK_IMPORTED_MODULE_10_vux_src_components_x_input_index_vue___default.a,
    XAddress: __WEBPACK_IMPORTED_MODULE_11_vux_src_components_x_address_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_12_vux_src_components_group_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_13_vux_src_components_x_header_index_vue___default.a,
    Cell: __WEBPACK_IMPORTED_MODULE_14_vux_src_components_cell_index_vue___default.a,
    Datetime: __WEBPACK_IMPORTED_MODULE_15_vux_src_components_datetime_index_vue___default.a,
    PopupPicker: __WEBPACK_IMPORTED_MODULE_16_vux_src_components_popup_picker_index_vue___default.a,
    KpBottomBtn: __WEBPACK_IMPORTED_MODULE_4__plugin_bottombtn___default.a,
    TransferDom: __WEBPACK_IMPORTED_MODULE_17_vux_src_directives_transfer_dom_index_js__["a" /* default */],
    Actionsheet: __WEBPACK_IMPORTED_MODULE_18_vux_src_components_actionsheet_index_vue___default.a,
    Picker: __WEBPACK_IMPORTED_MODULE_19_vux_src_components_picker_index_vue___default.a,
    Divider: __WEBPACK_IMPORTED_MODULE_20_vux_src_components_divider_index_vue___default.a,
    Toast: __WEBPACK_IMPORTED_MODULE_21_vux_src_components_toast_index_vue___default.a,
    industryChecker: __WEBPACK_IMPORTED_MODULE_9__plugin_industry_checker___default.a,
    Position: __WEBPACK_IMPORTED_MODULE_7__plugin_Position___default.a,
    KpFileUpload: __WEBPACK_IMPORTED_MODULE_8__plugin_KpFileUpload___default.a
  },
  data: function data() {
    return {
      corp_name: '',
      name: '',
      account: sessionStorage.accountPhone || sessionStorage.accountEmail,
      address: '',
      locationList: [],
      location: [],
      perchase_in_charge: '',
      loading: false,
      country: [],
      countryList: [],
      showSuccessToast: false,
      showErrorToast: false,
      errorRequestId: '',
      showMoreLocation: true,
      positionModel: false,
      isEdit: true,
      files: [],
      industrySubVisible: false,
      industryList: [],
      mainIndustry: [],
      subIndustry: []
    };
  },
  created: function created() {
    var _this = this;

    this.country = ['17230'];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__controller_basic__["c" /* getCountryList */])({
      callback: function callback(response) {
        if (response.code === 0 && response.data.length) {
          var country = response.data;
          var list = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(country), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _ref = _step.value;
              var countryId = _ref.countryId,
                  countryName = _ref.countryName;

              list.push({
                name: countryName,
                value: countryId,
                parent: '0'
              });
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.countryList = list;
        }
      }
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__controller_basic__["d" /* getAllAddress */])({
      callback: function callback(response) {
        if (response.code === 0) {
          var allAddress = response.data;
          var location = [];
          if (allAddress.provinces.length) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(allAddress.provinces), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _ref2 = _step2.value;
                var provinceId = _ref2.provinceId,
                    provinceName = _ref2.provinceName;

                location.push({
                  name: provinceName,
                  value: provinceId,
                  parent: 0
                });
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
          if (allAddress.citys.length) {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(allAddress.citys), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _ref3 = _step3.value;
                var _provinceId = _ref3.provinceId,
                    cityName = _ref3.cityName,
                    cityId = _ref3.cityId;

                location.push({
                  name: cityName,
                  value: cityId,
                  parent: _provinceId
                });
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }
          }
          if (allAddress.districts.length) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(allAddress.districts), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var _ref4 = _step4.value;
                var districtId = _ref4.districtId,
                    districtName = _ref4.districtName,
                    _cityId = _ref4.cityId;

                location.push({
                  name: districtName,
                  value: districtId,
                  parent: _cityId
                });
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }
          _this.locationList = location;
        }
      }
    });
  },

  watch: {
    country: function country(val) {
      if (val[0] !== '17230') {
        this.showMoreLocation = false;
      } else {
        this.showMoreLocation = true;
      }
    }
  },
  methods: {
    getWxAddress: function getWxAddress() {
      var _this2 = this;

      wx.openAddress({
        success: function success(res) {

          var temp = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this2.country));
          temp[0] = '17230';
          _this2.country = temp;

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__controller_basic__["e" /* exchange */])({
            cityName: res.cityName,
            countyName: res.countryName,
            provinceName: res.provinceName,
            callback: function callback(response) {
              var temp1 = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this2.location));
              temp1[0] = response.data.provinceId;
              temp1[1] = response.data.cityId;
              temp1[2] = response.data.districtId;
              _this2.location = temp1;
              _this2.address = res.detailInfo;
            }
          });
        },
        cancel: function cancel() {} });
    },
    onCountryChange: function onCountryChange() {
      if (this.country[0] !== '17230') {
        this.location[0] = 0;
        this.location[1] = 0;
        this.location[2] = 0;
      }
    },
    register: function register() {
      var _this3 = this;

      var corp_name = this.corp_name,
          name = this.name,
          address = this.address,
          account = this.account,
          location = this.location,
          country = this.country;

      var phone = '';
      var email = '';
      if (account.includes('@')) {
        email = account;
      } else {
        phone = account;
      }
      var storeImages = '';
      var imgSrcArr = [];
      if (this.files.length > 0) {
        this.files.forEach(function (item) {
          imgSrcArr.push(item.src);
        });
      } else {
        this.$vux.alert.show({
          content: '请上传门店图片'
        });
        return;
      }
      storeImages = imgSrcArr.join(',');
      if (!this.loading) {
        var request = {
          storeImages: storeImages,
          countryId: country[0],
          provinceId: location[0],
          cityId: location[1],
          districtId: location[2],
          corpAddress: address,
          corpAdminName: name,
          corpName: corp_name,
          email: email,
          phone: phone,
          corpType: localStorage.agentType == 2 ? 3 : 1,
          mainIndustryId: localStorage.mainIndustryId,
          corpVersion1: localStorage.corpVersion1,
          corpPlugin: localStorage.corpPlugin
        };
        if (this.subIndustry.length > 0) {
          this.subIndustry.forEach(function (item, index) {
            request['secondIndustryId' + (index + 1)] = _this3.subIndustry[index].id;
          });
        }
        if (localStorage.clueId && localStorage.clueId != 'undefined') {
          request.clueId = localStorage.clueId;
        } else {
          this.$vux.toast.show({
            text: '本次注册没有线索ID:' + localStorage.clueId,
            type: 'cancel',
            width: '180px'
          });
          return;
        }

        this.loading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__controller_corp__["a" /* registCorp */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request, {
          callback: function callback(response) {
            _this3.loading = false;
            _this3.showSuccessToast = true;
            _this3.showErrorToast = false;
            if (response.code === 0) {

              _this3.$router.push('/downLoad');
            }
          },
          errorback: function errorback(error) {
            _this3.loading = false;
            _this3.showSuccessToast = false;
          }
        }));
      }
    },
    checkForm: function checkForm() {
      var corp_name = this.corp_name,
          name = this.name,
          address = this.address,
          account = this.account,
          location = this.location;

      if (!corp_name || corp_name.length > 40) {
        this.$vux.toast.show({
          text: '企业名为空或超出40个字',
          type: 'cancel',
          width: '140px'
        });
        return;
      }
      if (name.length < 2 || name.length > 20) {
        this.$vux.toast.show({
          text: '联系人长度应为2-20个字',
          type: 'cancel',
          width: '200px'
        });
        return;
      }
      if (!account) {
        this.$vux.toast.show({
          text: '账号不能为空',
          type: 'cancel',
          width: '200px'
        });
        return;
      } else {
        account = account.replace(/\s/g, '');
        if (!/\d$/.test(account)) {
          if (account.length > 40 || !mailreg.test(account)) {
            this.$vux.toast.show({
              text: '邮箱填写错误',
              type: 'cancel',
              width: '200px'
            });
            return;
          }
        } else {
          if (!/^1\d{10}$/.test(account)) {
            this.$vux.toast.show({
              text: '手机号码格式填写错误' + account,
              type: 'cancel',
              width: '200px'
            });
            return;
          }
        }
      }
      if (location.length === 0) {
        this.$vux.toast.show({
          text: '请选择地区范围',
          type: 'cancel',
          width: '200px'
        });
        return;
      }
      if (!address || address.length > 200) {
        this.$vux.toast.show({
          text: '请输入200字以内的详细地址',
          type: 'cancel',
          width: '200px'
        });
        return;
      }
      this.register();
    },
    updateSuccess: function updateSuccess(files, obj) {
      console.log(files, obj);
      this.files = files;
    },
    openIndustrySub: function openIndustrySub() {
      console.log('open!');
      this.industrySubVisible = true;
    },
    closeIndustrySub: function closeIndustrySub() {
      this.industrySubVisible = false;
    },
    industrySubOk: function industrySubOk(data) {
      console.log('industry sub ok!', data);
      this.subIndustry = data;
      this.industrySubVisible = false;
    },
    getIndustryList: function getIndustryList() {
      var _this4 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__controller_basic__["f" /* getIndustry2 */])().then(function (res) {
        _this4.industryList = res.data;
      });
    },
    locationFn: function locationFn(loc) {
      var _this5 = this;

      var params = {
        cityName: loc.cityname,
        address: loc.poiaddress
      };
      this.exchange(params, function (res) {
        if (res && res.provinceId && res.cityId && res.districtId) {
          _this5.location = [res.provinceId, res.cityId, res.districtId];
          _this5.address = _this5.getAddress(loc.poiaddress);
        }
      });
      this.positionModel = false;
    },
    getAddress: function getAddress(poiaddress) {
      var mak = ['区', '县'];
      if (poiaddress) {
        if (poiaddress.indexOf(mak[0]) > -1 && poiaddress.indexOf(mak[1]) > -1) {
          return poiaddress.substring(poiaddress.indexOf(mak[0]) + 1);
        } else if (poiaddress.indexOf(mak[0]) > -1) {
          return poiaddress.substring(poiaddress.indexOf(mak[0]) + 1);
        } else if (poiaddress.indexOf(mak[1]) > -1) {
          return poiaddress.substring(poiaddress.indexOf(mak[1]) + 1);
        } else {
          return poiaddress;
        }
      } else {
        return '';
      }
    },
    exchange: function exchange(params, _callback) {
      var _this6 = this;

      this.$vux.loading.show({ text: '' });
      var request = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(params, {
        callback: function callback(res) {
          _callback && _callback(res.data);
          _this6.$vux.loading.hide();
        },
        errorback: function errorback(error) {
          _this6.$vux.loading.hide();
        }
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__controller_basic__["g" /* exchange2 */])(request);
    }
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_previewer_index_vue__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_previewer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_previewer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(39);






var setHeader = {
  'kp-token': sessionStorage.token || '',
  'kp-request-id': '5' + new Date().getTime().toString() + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["a" /* randomn */])(4),
  'kp-source': 5,
  'kp-version': '',
  'kp-language': 'zh_CN'
};
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      setHeader: setHeader,
      uploadUrl: '',
      files: [],
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      }
    };
  },

  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_1_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  computed: {
    getClassType: function getClassType() {
      if (this.type == 1) {
        return {
          li: 'img-item',
          delIcon: 'del-icon'
        };
      } else if (this.type == 2) {
        return {
          li: 'img-line-item',
          delIcon: 'del-icon-small'
        };
      } else {
        return {
          li: 'img-item',
          delIcon: 'del-icon'
        };
      }
    }
  },
  props: {
    name: {
      type: String,
      default: 'files'
    },
    type: {
      type: Number,
      default: 1 // 1 多选铺开大图显示模式 2 单个行内显示
    },
    multiple: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 1
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    /**
    * value => [{
    blob: String, // 图片路径
    name: String, // 图片名称
    src: String, // 大图路径
    response: {
    code: 0,  // 服务端响应码
    data: [{
    name: String, // 图片名称
    relativePath: String 
    }]
    }
    }]
    */
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    Previewer: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_previewer_index_vue___default.a
  },
  watch: {
    value: {
      handler: function handler(newValue) {
        this.files = newValue;
      }
    }
  },
  mounted: function mounted() {
    var uploadUrl1 = 'https://api.kuaipiyun.com/file/oss/corp/upload';
    var uploadUrl2 = 'https://api.kuaipiyun.com/file/oss/upload/back/single';

    if (this.name == 'files') {
      this.uploadUrl = uploadUrl1;
    } else if (this.name == 'file') {
      this.uploadUrl = uploadUrl2;
    } else {
      this.uploadUrl = uploadUrl1;
    }
  },

  methods: {
    getImgUrl: __WEBPACK_IMPORTED_MODULE_2__lib_utils__["b" /* getImgUrl */],
    getImgFileReallyName: __WEBPACK_IMPORTED_MODULE_2__lib_utils__["c" /* getImgFileReallyName */],
    inputFile: function inputFile(newFile, oldFile) {
      if (newFile && newFile.active && newFile.response && newFile.response.code >= 0) {
        this.$vux.loading.hide();
        if (newFile.response.code != 0) {
          this.$emit('update-error');
          this.$vux.toast.text(newFile.response.msg, 'top');
          return;
        } else {

          newFile.src = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["b" /* getImgUrl */])(newFile.response.data[0].relativePath);
          this.$emit('update-success', this.files.concat([]), {
            type: 'add',
            file: newFile
          });
        }
      }
    },
    inputFilter: function inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {

        if (newFile.size > 20971520) {
          this.$vux.toast.show({
            text: '图片不能超过20M',
            type: 'cancel',
            width: '140px'
          });
          return prevent();
        }

        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent();
        }
        this.$vux.loading.show({ text: '上传中...' });

        newFile.blob = '';
        var URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["d" /* makeImgFileName */])(newFile.name);
          newFile.blob = URL.createObjectURL(newFile.file);
          newFile.active = true;
        }
      }
      if (!newFile && oldFile) {}
    },
    preview: function preview(index) {
      this.$refs.previewer.show(index);
    },
    del: function del(file) {
      this.$refs.upload.remove(file);
      this.$emit('update-success', this.files.concat([]), {
        type: 'delete',
        file: file
      });
    }
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_popup_index_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_popup_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_popup_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(17);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'position',
  data: function data() {
    return {
      show: false,
      iframeSrc: ''
    };
  },

  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_1_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  props: {
    visable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Popup: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_popup_index_vue___default.a
  },
  watch: {
    visable: function visable(value) {
      this.show = value;
      if (this.show) {
        this.iframeSrc = 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=6OOBZ-ASY6X-OYW4U-7PMGO-A2RLK-6EBQR&referer=myapp';
      }
    }
  },
  created: function created() {
    var self = this;
    window.addEventListener('message', function (event) {

      var loc = event.data;
      if (loc && loc.module == 'locationPicker') {
        // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
        self.$emit('location', loc);
      }
    }, false);
  },
  mounted: function mounted() {},

  methods: {
    onHide: function onHide() {
      this.$emit('on-hide');
    }
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue___default.a
  },
  props: {
    title: String,
    disabledText: String,
    disabled: Boolean
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_header_index_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_popup_index_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_popup_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_popup_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_checker_checker_vue__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_checker_checker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_checker_checker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_checker_checker_item_vue__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_checker_checker_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_checker_checker_item_vue__);








var agentStaffRes = sessionStorage.getItem('agentStaffRes') ? JSON.parse(sessionStorage.getItem('agentStaffRes')) : {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'industryChecker',
  data: function data() {
    return {
      selectedIndustry: [],
      industryList: []
    };
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number
    },
    title: {
      type: String,
      default: '请选择行业'
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disable: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_0_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  components: {
    Popup: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_popup_index_vue___default.a,
    PopupHeader: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_header_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default.a,
    Checker: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_checker_checker_vue___default.a,
    CheckerItem: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_checker_checker_item_vue___default.a
  },
  watch: {
    value: function value(val) {
      var _this = this;

      if (val && this.disable && this.disable[0]) {
        this.selectedIndustry.forEach(function (item, index) {
          if (item.split('|')[0] == _this.disable[0].id) {
            _this.selectedIndustry.splice(index, 1);
          }
        });
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.agentStaffId = agentStaffRes.agentStaffId;
  },

  methods: {
    onHide: function onHide() {
      this.$emit('close');
    },
    onConfirm: function onConfirm() {
      var data = [];
      this.selectedIndustry.forEach(function (item) {
        data.push({
          name: item.split('|')[1],
          id: item.split('|')[0]
        });
      });
      this.$emit('ok', data);
    },
    checkChange: function checkChange(val) {
      console.log(val);
      console.log('不可选', this.disable);
    },
    disableItem: function disableItem(item) {
      var bl = false;
      if (this.disable && this.disable[0] && this.disable[0].id == item.industryId) {
        bl = true;
      }
      if (this.selectedIndustry.length == this.max) {
        bl = true;
        this.selectedIndustry.forEach(function (selected) {
          if (selected.split('|')[0] == item.industryId) {
            bl = false;
          }
        });
      }

      return bl;
    }
  }
});

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAMNJREFUSA1jZEADnZ2dW////++FJkwWl5GRcVt5ebk3smYmZA6ITS3LcJmFYSG6A6jNZ8FnYEVFBSM+eVxyHR0d/3HJ0d2HoxbiigqyxUeDlOygw6VxNEhxhQzZ4qNBSnbQ4dI4GqS4QoZscbwVML6KlFwbB38cAlti24FYFoq3k+pTcnyYBmz6PQFhoGVp9LCQVDtQ1ONNNCgqEZxZwMYyzGezEMLEsUi2ENhQ9gQa/Zg44zFVYcQhqHmOqYxska3oOgEs4CVDEF5uWgAAAABJRU5ErkJggg=="

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAYVJREFUSA3tVbFOhEAQBWKMEK2pjDFe608Yrz1/QSwu2lAdgc4Wgr1W4jfYXHHGn7A1MSYmhtpGKcC3hDHjsceCJBQXSTbz9u3Mezt7sKdp6/7obRuMominKIqZrusTxJGoA34Gvke88n3/o41WK8M4jo/yPL+F+J5MFIavhmGceZ73KFvnnNKwMnuAWWMuTAuYHqtMG0XEMWJ3T7wzCL+AW1S7HmNtnzoQnQIfNh3vBiXLIsRm4Pkx3pmmee667pfIT5JkK03Ta8BTMa82JmouxVz2GDKScSeERWeWZf2YCd5xnE/bti+qrstU4AnVyKLK8IAVLagzxpWmmNMRiy7LN5jncKwy3GbJ7wwvQ77Ga5bzNJVhraAvMbhh7bMIw7Do2wWvD4Lgl8fgHf4b8p+jxPiw5xi71ZjXEhTEX450irvyTQxoTxX6teXOhpt4SIVj4lSxs2GWZTckyjFxqtjZEHflmEQ5Jk4VOxuqBFXrgxs2/gGv2m2f62/wDgc3XHVq68N/Awi0dSm73gFUAAAAAElFTkSuQmCC"

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup-picker', {
    attrs: {
      "fixed-columns": _vm.hideDistrict ? 2 : 0,
      "columns": _vm.columns,
      "data": _vm.list,
      "title": _vm.title,
      "show-name": "",
      "inline-desc": _vm.inlineDesc,
      "placeholder": _vm.placeholder,
      "value-text-align": _vm.valueTextAlign,
      "confirm-text": _vm.confirmText,
      "cancel-text": _vm.cancelText,
      "display-format": _vm.displayFormat,
      "popup-style": _vm.popupStyle,
      "popup-title": _vm.popupTitle,
      "show": _vm.showValue,
      "disabled": _vm.disabled
    },
    on: {
      "update:show": function($event) {
        _vm.showValue = $event
      },
      "on-shadow-change": _vm.onShadowChange,
      "on-hide": _vm.emitHide,
      "on-show": function($event) {
        return _vm.$emit('on-show')
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function(props) {
        return [_vm._t("title", function() {
          return [(props.labelTitle) ? _c('label', {
            class: [props.labelClass, _vm.labelClass],
            style: (props.labelStyle),
            domProps: {
              "innerHTML": _vm._s(props.labelTitle)
            }
          }) : _vm._e()]
        }, {
          "labelClass": props.labelClass,
          "labelStyle": props.labelStyles,
          "labelTitle": props.title
        })]
      }
    }], null, true),
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "back"
  }, [_c('div', {
    staticClass: "register"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('img', {
    attrs: {
      "src": _vm.agentStaffAvatar,
      "alt": ""
    }
  }), _vm._v(_vm._s(this.agentStaffName) + "\n            ")])]), _vm._v(" "), _c('h1', [_vm._v("邀请你注册使用快批")]), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "usernamewrapper"
  }, [_c('div', {
    staticClass: "imgwrapper"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(284)
    }
  })]), _vm._v(" "), _c('input', {
    ref: "username",
    staticClass: "username",
    attrs: {
      "type": "email",
      "placeholder": "中国大陆手机/邮箱"
    },
    on: {
      "blur": _vm.limitcontent
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "passwordwarp"
  }, [_c('div', {
    staticClass: "imgwrapper"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(286)
    }
  })]), _vm._v(" "), _c('input', {
    ref: "password",
    staticClass: "password",
    attrs: {
      "type": "number",
      "placeholder": "填写验证码"
    }
  }), _vm._v(" "), _c('input', {
    ref: "passwordbtn",
    staticClass: "passwordbtn",
    attrs: {
      "type": "button",
      "value": "获取验证码"
    },
    on: {
      "click": _vm.getcode
    }
  })]), _vm._v(" "), _c('div', {
    ref: "verificate",
    staticClass: "verificate"
  }), _vm._v(" "), _c('input', {
    ref: "startbtn",
    staticClass: "registerbtn",
    attrs: {
      "type": "button",
      "disabled": false,
      "value": "确定"
    },
    on: {
      "click": _vm.submit
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-toast"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMask && _vm.show),
      expression: "isShowMask && show"
    }],
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.currentTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-toast",
    class: _vm.toastClass,
    style: ({
      width: _vm.width
    })
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'text'),
      expression: "type !== 'text'"
    }],
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style),
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style)
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-checker-item",
    class: _vm.classNames,
    on: {
      "click": _vm.select
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-header"
  }, [_c('div', {
    staticClass: "vux-header-left"
  }, [_vm._t("overwrite-left", function() {
    return [_c('transition', {
      attrs: {
        "name": _vm.transition
      }
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm._leftOptions.showBack),
        expression: "_leftOptions.showBack"
      }],
      staticClass: "vux-header-back",
      on: {
        "click": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "preventDefault", undefined, $event.key, undefined)) { return null; }
        }, _vm.onClickBack]
      }
    }, [_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": _vm.transition
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm._leftOptions.showBack),
        expression: "_leftOptions.showBack"
      }],
      staticClass: "left-arrow",
      on: {
        "click": _vm.onClickBack
      }
    })])]
  }), _vm._v(" "), _vm._t("left")], 2), _vm._v(" "), (!_vm.shouldOverWriteTitle) ? _c('h1', {
    staticClass: "vux-header-title",
    on: {
      "click": function($event) {
        return _vm.$emit('on-click-title')
      }
    }
  }, [_vm._t("default", function() {
    return [_c('transition', {
      attrs: {
        "name": _vm.transition
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.title),
        expression: "title"
      }]
    }, [_vm._v(_vm._s(_vm.title))])])]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.shouldOverWriteTitle) ? _c('div', {
    staticClass: "vux-header-title-area"
  }, [_vm._t("overwrite-title")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vux-header-right"
  }, [(_vm.rightOptions.showMore) ? _c('a', {
    staticClass: "vux-header-more",
    on: {
      "click": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "preventDefault", undefined, $event.key, undefined)) { return null; }
      }, function($event) {
        return _vm.$emit('on-click-more')
      }]
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("right")], 2)])
},staticRenderFns: []}

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.title) ? _c('div', {
    staticClass: "weui-cells__title",
    style: (_vm.cleanStyle({
      color: _vm.titleColor
    })),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("title"), _vm._v(" "), _c('div', {
    staticClass: "weui-cells",
    class: {
      'vux-no-group-title': !_vm.title
    },
    style: (_vm.cleanStyle({
      marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
    }))
  }, [_vm._t("after-title"), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.footerTitle) ? _c('div', {
    staticClass: "weui-cells__title vux-group-footer-title",
    style: (_vm.cleanStyle({
      color: _vm.footerTitleColor
    })),
    domProps: {
      "innerHTML": _vm._s(_vm.footerTitle)
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-customer"
  }, [_c('div', {
    staticClass: "contain"
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      },
      "title": "企业注册"
    },
    on: {
      "on-click-back": function($event) {
        return _vm.$router.push({
          path: '/login'
        })
      }
    }
  }), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0",
      "label-width": "90px"
    }
  }, [_c('x-input', {
    attrs: {
      "title": "*手机/邮箱",
      "disabled": "",
      "placeholder": "中国大陆手机或邮箱",
      "keyboard": "text"
    },
    on: {
      "on-blur": function($event) {
        _vm.account = _vm.holdEmoji(_vm.account).trim()
      }
    },
    model: {
      value: (_vm.account),
      callback: function($$v) {
        _vm.account = $$v
      },
      expression: "account"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "*联系人",
      "placeholder": "必填",
      "required": "",
      "keyboard": "text"
    },
    on: {
      "on-blur": function($event) {
        _vm.name = _vm.holdEmoji(_vm.name).trim()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "*企业名",
      "placeholder": "必填",
      "required": "",
      "keyboard": "text"
    },
    on: {
      "on-blur": function($event) {
        _vm.corp_name = _vm.holdEmoji(_vm.corp_name).trim()
      }
    },
    model: {
      value: (_vm.corp_name),
      callback: function($$v) {
        _vm.corp_name = $$v
      },
      expression: "corp_name"
    }
  }), _vm._v(" "), (_vm.mainIndustry.length > 0) ? _c('cell', {
    attrs: {
      "title": "副行业",
      "isLink": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openIndustrySub.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": ""
    },
    slot: "default"
  }, [(_vm.subIndustry && _vm.subIndustry.length > 0) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.subIndustry.map(function (item) {
    return item.name
  }).join('/')))])]) : _c('span', [_vm._v("点击选择")])])]) : _vm._e(), _vm._v(" "), _c('popup-picker', {
    attrs: {
      "title": "*国家",
      "columns": 1,
      "show-name": "",
      "placeholder": "请选择国家",
      "data": _vm.countryList
    },
    on: {
      "on-change": _vm.onCountryChange
    },
    model: {
      value: (_vm.country),
      callback: function($$v) {
        _vm.country = $$v
      },
      expression: "country"
    }
  }), _vm._v(" "), (_vm.showMoreLocation) ? _c('x-address', {
    attrs: {
      "title": "*地区",
      "placeholder": "请选择地区",
      "raw-value": "",
      "list": _vm.locationList,
      "value-text-align": "right"
    },
    model: {
      value: (_vm.location),
      callback: function($$v) {
        _vm.location = $$v
      },
      expression: "location"
    }
  }) : _vm._e(), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "*详细地址",
      "placeholder": "请输入详细地址",
      "text-align": "right",
      "keyboard": "address"
    },
    on: {
      "on-blur": function($event) {
        _vm.address = _vm.holdEmoji(_vm.address).trim()
      }
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.positionModel = true
      }
    },
    slot: "right"
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "value": "*请上传门店图片"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("门店照片")])]), _vm._v(" "), _c('kp-file-upload', {
    attrs: {
      "name": 'files',
      "max-length": 6,
      "is-edit": _vm.isEdit,
      "multiple": true
    },
    on: {
      "update-success": _vm.updateSuccess,
      "update-error": function (res) { return (_vm.files = _vm.files.concat([])); }
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  })], 1)], 1), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "success",
      "width": "150px",
      "time": 800
    },
    on: {
      "on-hide": function($event) {
        return _vm.$router.go(-1)
      }
    },
    model: {
      value: (_vm.showSuccessToast),
      callback: function($$v) {
        _vm.showSuccessToast = $$v
      },
      expression: "showSuccessToast"
    }
  }, [_vm._v("保存成功")]), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "cancel",
      "width": "150px",
      "time": 1000
    },
    model: {
      value: (_vm.showErrorToast),
      callback: function($$v) {
        _vm.showErrorToast = $$v
      },
      expression: "showErrorToast"
    }
  }, [_vm._v("保存失败,没有获取到错误信息，requestid是：" + _vm._s(this.errorRequestId))]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.getWxAddress
    }
  }, [_vm._v("一键获取微信地址")]), _vm._v(" "), _c('kp-bottom-btn', {
    attrs: {
      "title": "完成注册",
      "disabledText": "正在提交",
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.checkForm.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('industry-checker', {
    attrs: {
      "value": _vm.industrySubVisible,
      "max": 2,
      "disable": _vm.mainIndustry,
      "title": "请选择企业副营行业",
      "data": _vm.industryList
    },
    on: {
      "close": _vm.closeIndustrySub,
      "ok": _vm.industrySubOk
    }
  }), _vm._v(" "), _c('position', {
    attrs: {
      "visable": _vm.positionModel
    },
    on: {
      "on-hide": function($event) {
        _vm.positionModel = false
      },
      "location": _vm.locationFn
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-flexbox",
    class: {
      'vux-flex-col': _vm.orient === 'vertical',
      'vux-flex-row': _vm.orient === 'horizontal'
    },
    style: (_vm.styles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    staticClass: "industry-checker"
  }, [_c('popup', {
    attrs: {
      "value": _vm.value,
      "position": "bottom"
    },
    on: {
      "on-hide": _vm.onHide
    }
  }, [_c('popup-header', {
    attrs: {
      "left-text": "取消",
      "right-text": "确定",
      "title": _vm.title
    },
    on: {
      "on-click-left": _vm.onHide,
      "on-click-right": _vm.onConfirm
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('checker', {
    attrs: {
      "max": _vm.max,
      "type": "checkbox",
      "default-item-class": "item-class",
      "selected-item-class": "item-selected",
      "disabled-item-class": "item-disable"
    },
    on: {
      "on-change": _vm.checkChange
    },
    model: {
      value: (_vm.selectedIndustry),
      callback: function($$v) {
        _vm.selectedIndustry = $$v
      },
      expression: "selectedIndustry"
    }
  }, _vm._l((_vm.data), function(item) {
    return _c('checker-item', {
      key: item.industryId,
      attrs: {
        "value": item.industryId + '|' + item.industryNameZhCn,
        "disabled": _vm.disableItem(item)
      }
    }, [_vm._v("\n          " + _vm._s(item.industryNameZhCn) + "\n        ")])
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-confirm"
  }, [_c('x-dialog', {
    attrs: {
      "dialog-class": _vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,
      "hide-on-blur": _vm.hideOnBlur,
      "mask-z-index": _vm.maskZIndex
    },
    on: {
      "on-hide": function($event) {
        return _vm.$emit('on-hide')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [(!!_vm.title) ? _c('div', {
    staticClass: "weui-dialog__hd",
    class: {
      'with-no-content': !_vm.showContent
    }
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.showContent) ? [(!_vm.showInput) ? _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", function() {
    return [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.content)
      }
    })]
  })], 2) : _c('div', {
    staticClass: "vux-prompt"
  }, [(((_vm.getInputAttrs()).type) === 'checkbox') ? _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    ref: "input",
    staticClass: "vux-prompt-msgbox",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.msg) ? _vm._i(_vm.msg, null) > -1 : (_vm.msg)
    },
    on: {
      "touchend": _vm.setInputFocus,
      "change": function($event) {
        var $$a = _vm.msg,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.msg = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.msg = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.msg = $$c
        }
      }
    }
  }, 'input', _vm.getInputAttrs(), false)) : (((_vm.getInputAttrs()).type) === 'radio') ? _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    ref: "input",
    staticClass: "vux-prompt-msgbox",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.msg, null)
    },
    on: {
      "touchend": _vm.setInputFocus,
      "change": function($event) {
        _vm.msg = null
      }
    }
  }, 'input', _vm.getInputAttrs(), false)) : _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    ref: "input",
    staticClass: "vux-prompt-msgbox",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": (_vm.getInputAttrs()).type
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "touchend": _vm.setInputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  }, 'input', _vm.getInputAttrs(), false))])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [(_vm.showCancelButton) ? _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText || '取消'))]) : _vm._e(), _vm._v(" "), (_vm.showConfirmButton) ? _c('a', {
    staticClass: "weui-dialog__btn",
    class: ("weui-dialog__btn_" + _vm.confirmType),
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onConfirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText || '确定'))]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    attrs: {
      "height": "80%"
    },
    on: {
      "on-hide": _vm.onHide
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('iframe', {
    attrs: {
      "id": "mapPage",
      "width": "100%",
      "height": "100%",
      "frameborder": "0",
      "src": _vm.iframeSrc
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: [_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']
  })
},staticRenderFns: []}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-cell-box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCell),
      expression: "showCell"
    }],
    staticClass: "weui-cell vux-tap-active",
    class: {
      'weui-cell_access': !_vm.disabled
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_vm._t("title", function() {
    return [(_vm.title) ? _c('label', {
      staticClass: "weui-label",
      class: _vm.labelClass,
      style: (_vm.labelStyles),
      domProps: {
        "innerHTML": _vm._s(_vm.title)
      }
    }) : _vm._e()]
  }, {
    "labelClass": "weui-label",
    "labelStyle": _vm.labelStyles,
    "labelTitle": _vm.title
  }), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-cell-primary vux-popup-picker-select-box"
  }, [_c('div', {
    staticClass: "vux-popup-picker-select",
    style: ({
      textAlign: _vm.valueTextAlign
    })
  }, [(!_vm.displayFormat && !_vm.showName && _vm.value.length) ? _c('span', {
    staticClass: "vux-popup-picker-value vux-cell-value"
  }, [_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]) : _vm._e(), _vm._v(" "), (!_vm.displayFormat && _vm.showName && _vm.value.length) ? _c('span', {
    staticClass: "vux-popup-picker-value vux-cell-value"
  }, [_vm._v(_vm._s(_vm._f("value2name")(_vm.value, _vm.data)))]) : _vm._e(), _vm._v(" "), (_vm.displayFormat && _vm.value.length) ? _c('span', {
    staticClass: "vux-popup-picker-value vux-cell-value"
  }, [_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]) : _vm._e(), _vm._v(" "), (!_vm.value.length && _vm.placeholder) ? _c('span', {
    staticClass: "vux-popup-picker-placeholder vux-cell-placeholder",
    domProps: {
      "textContent": _vm._s(_vm.placeholder)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom",
      value: (_vm.isTransferDom),
      expression: "isTransferDom"
    }]
  }, [_c('popup', {
    staticClass: "vux-popup-picker",
    attrs: {
      "id": ("vux-popup-picker-" + _vm.uuid),
      "popup-style": _vm.popupStyle
    },
    on: {
      "on-hide": _vm.onPopupHide,
      "on-show": _vm.onPopupShow
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "vux-popup-picker-container"
  }, [_c('popup-header', {
    attrs: {
      "left-text": _vm.cancelText || '取消',
      "right-text": _vm.confirmText || '完成',
      "title": _vm.popupTitle
    },
    on: {
      "on-click-left": function($event) {
        return _vm.onHide(false)
      },
      "on-click-right": function($event) {
        return _vm.onHide(true)
      }
    }
  }), _vm._v(" "), _c('picker', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "fixed-columns": _vm.fixedColumns,
      "container": '#vux-popup-picker-' + _vm.uuid,
      "column-width": _vm.columnWidth
    },
    on: {
      "on-change": _vm.onPickerChange
    },
    model: {
      value: (_vm.tempValue),
      callback: function($$v) {
        _vm.tempValue = $$v
      },
      expression: "tempValue"
    }
  })], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "vux-divider"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-picker"
  }, [_c('flexbox', {
    attrs: {
      "gutter": 0
    }
  }, _vm._l((_vm.currentData), function(one, index) {
    return _c('flexbox-item', {
      key: index,
      staticStyle: {
        "margin-left": "0"
      },
      attrs: {
        "span": _vm.columnWidth && _vm.columnWidth[index]
      }
    }, [_c('div', {
      staticClass: "vux-picker-item",
      attrs: {
        "id": ("vux-picker-" + _vm.uuid + "-" + index)
      }
    })])
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "show": _vm.disabled,
      "text": _vm.disabledText
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn",
    class: {
      disabled: _vm.disabled
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)
},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "background"
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      },
      "title": "已属于如下企业"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "numberCorp"
  }, [_vm._v("你已经属于" + _vm._s(this.corpList.length) + "家企业")]), _vm._v(" "), _c('ul', _vm._l((_vm.corpList), function(item) {
    return _c('li', {
      key: item.corpId
    }, [_vm._v(_vm._s(item.corpName))])
  }), 0)], 1), _vm._v(" "), (_vm.isContinue) ? _c('kp-bottom-btn', {
    attrs: {
      "title": "继续注册"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/register')
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-dialog",
    class: {
      'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-mask",
    style: (_vm.maskStyle),
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.hide.apply(null, arguments)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: _vm.dialogClass,
    style: (_vm.dialogStyle)
  }, [_vm._t("default")], 2)])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-panel weui-panel_access"
  }, [(_vm.header) ? _c('div', {
    staticClass: "weui-panel__hd",
    domProps: {
      "innerHTML": _vm._s(_vm.header)
    },
    on: {
      "click": _vm.onClickHeader
    }
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui-panel__bd"
  }, [_vm._t("body", function() {
    return [(_vm.type === '1') ? _vm._l((_vm.list), function(item) {
      return _c('a', {
        staticClass: "weui-media-box weui-media-box_appmsg",
        attrs: {
          "href": _vm.getUrl(item.url)
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.onItemClick(item)
          }
        }
      }, [(item.src) ? _c('div', {
        staticClass: "weui-media-box__hd"
      }, [_c('img', {
        staticClass: "weui-media-box__thumb",
        attrs: {
          "src": item.src,
          "alt": ""
        },
        on: {
          "error": function($event) {
            return _vm.onImgError(item, $event)
          }
        }
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "weui-media-box__bd"
      }, [_c('h4', {
        staticClass: "weui-media-box__title",
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "weui-media-box__desc",
        domProps: {
          "innerHTML": _vm._s(item.desc)
        }
      })])])
    }) : _vm._e(), _vm._v(" "), (_vm.type === '2') ? _vm._l((_vm.list), function(item) {
      return _c('div', {
        staticClass: "weui-media-box weui-media-box_text",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.onItemClick(item)
          }
        }
      }, [_c('h4', {
        staticClass: "weui-media-box__title",
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "weui-media-box__desc",
        domProps: {
          "innerHTML": _vm._s(item.desc)
        }
      })])
    }) : _vm._e(), _vm._v(" "), (_vm.type === '3') ? [_c('div', {
      staticClass: "weui-media-box weui-media-box_small-appmsg"
    }, [_c('div', {
      staticClass: "weui-cells"
    }, _vm._l((_vm.list), function(item) {
      return _c('a', {
        staticClass: "weui-cell weui-cell_access",
        attrs: {
          "href": _vm.getUrl(item.url)
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.onItemClick(item)
          }
        }
      }, [_c('div', {
        staticClass: "weui-cell__hd"
      }, [_c('img', {
        staticStyle: {
          "width": "20px",
          "margin-right": "5px",
          "display": "block"
        },
        attrs: {
          "src": item.src,
          "alt": ""
        },
        on: {
          "error": function($event) {
            return _vm.onImgError(item, $event)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "weui-cell__bd"
      }, [_c('p', {
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      })]), _vm._v(" "), _c('span', {
        staticClass: "weui-cell__ft"
      })])
    }), 0)])] : _vm._e(), _vm._v(" "), (_vm.type === '4') ? _vm._l((_vm.list), function(item) {
      return _c('div', {
        staticClass: "weui-media-box weui-media-box_text",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.onItemClick(item)
          }
        }
      }, [_c('h4', {
        staticClass: "weui-media-box__title",
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "weui-media-box__desc",
        domProps: {
          "innerHTML": _vm._s(item.desc)
        }
      }), _vm._v(" "), (item.meta) ? _c('ul', {
        staticClass: "weui-media-box__info"
      }, [_c('li', {
        staticClass: "weui-media-box__info__meta",
        domProps: {
          "innerHTML": _vm._s(item.meta.source)
        }
      }), _vm._v(" "), _c('li', {
        staticClass: "weui-media-box__info__meta",
        domProps: {
          "innerHTML": _vm._s(item.meta.date)
        }
      }), _vm._v(" "), _c('li', {
        staticClass: "weui-media-box__info__meta weui-media-box__info__meta_extra",
        domProps: {
          "innerHTML": _vm._s(item.meta.other)
        }
      })]) : _vm._e()])
    }) : _vm._e(), _vm._v(" "), (_vm.type === '5') ? _vm._l((_vm.list), function(item) {
      return _c('div', {
        staticClass: "weui-media-box weui-media-box_text",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.onItemClick(item)
          }
        }
      }, [_c('div', {
        staticClass: "weui-media-box_appmsg"
      }, [(item.src) ? _c('div', {
        staticClass: "weui-media-box__hd"
      }, [_c('img', {
        staticClass: "weui-media-box__thumb",
        attrs: {
          "src": item.src,
          "alt": ""
        },
        on: {
          "error": function($event) {
            return _vm.onImgError(item, $event)
          }
        }
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "weui-media-box__bd"
      }, [_c('h4', {
        staticClass: "weui-media-box__title",
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "weui-media-box__desc",
        domProps: {
          "innerHTML": _vm._s(item.desc)
        }
      })])]), _vm._v(" "), (item.meta) ? _c('ul', {
        staticClass: "weui-media-box__info"
      }, [_c('li', {
        staticClass: "weui-media-box__info__meta",
        domProps: {
          "innerHTML": _vm._s(item.meta.source)
        }
      }), _vm._v(" "), _c('li', {
        staticClass: "weui-media-box__info__meta",
        domProps: {
          "innerHTML": _vm._s(item.meta.date)
        }
      }), _vm._v(" "), _c('li', {
        staticClass: "weui-media-box__info__meta weui-media-box__info__meta_extra",
        domProps: {
          "innerHTML": _vm._s(item.meta.other)
        }
      })]) : _vm._e()])
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-panel__ft"
  }, [(_vm.footer && _vm.footer.title && _vm.type !== '3') ? _c('a', {
    staticClass: "weui-cell weui-cell_access weui-cell_link",
    attrs: {
      "href": _vm.getUrl(_vm.footer.url)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClickFooter.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "weui-cell__bd",
    domProps: {
      "innerHTML": _vm._s(_vm.footer.title)
    }
  })]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "vux-datetime weui-cell",
    class: {
      'weui-cell_access': !_vm.readonly
    },
    attrs: {
      "data-cancel-text": '取消',
      "data-confirm-text": '确定',
      "href": "javascript:"
    }
  }, [_vm._t("default", function() {
    return [_c('div', [_vm._t("title", function() {
      return [_c('p', {
        class: _vm.labelClass,
        style: (_vm.styles),
        domProps: {
          "innerHTML": _vm._s(_vm.title)
        }
      })]
    }), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "weui-cell__ft vux-cell-primary vux-datetime-value",
      style: ({
        textAlign: _vm.valueTextAlign
      })
    }, [(!_vm.currentValue && _vm.placeholder) ? _c('span', {
      staticClass: "vux-cell-placeholder"
    }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), (_vm.currentValue) ? _c('span', {
      staticClass: "vux-cell-value"
    }, [_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]) : _vm._e(), _vm._v(" "), _c('icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.valid),
        expression: "!valid"
      }],
      staticClass: "vux-input-icon",
      attrs: {
        "type": "warn",
        "title": _vm.firstError
      }
    })], 1)]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-input weui-cell",
    class: {
      'weui-cell_warn': _vm.showWarn,
      'disabled': _vm.disabled,
      'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
    }
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [(_vm.hasRestrictedLabel) ? _c('div', {
    style: (_vm.labelStyles)
  }, [_vm._t("restricted-label")], 2) : _vm._e(), _vm._v(" "), _vm._t("label", function() {
    return [(_vm.title) ? _c('label', {
      staticClass: "weui-label",
      class: _vm.labelClass,
      style: ({
        width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed,
        textAlign: _vm.$parent.labelAlign,
        marginRight: _vm.$parent.labelMarginRight
      }),
      attrs: {
        "for": ("vux-x-input-" + _vm.uuid)
      },
      domProps: {
        "innerHTML": _vm._s(_vm.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd weui-cell__primary",
    class: _vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''
  }, [(!_vm.type || _vm.type === 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "text",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "number",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'email') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "email",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "password",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'tel') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "tel",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),
      expression: "!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"
    }],
    attrs: {
      "type": "clear"
    },
    nativeOn: {
      "touchstart": function($event) {
        return _vm.clear.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWarn),
      expression: "showWarn"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn",
      "title": !_vm.valid ? _vm.firstError : ''
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClickErrorIcon.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid) ? _c('icon', {
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClickErrorIcon.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),
      expression: "!novalidate && equalWith && equalWith === currentValue && valid"
    }],
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.novalidate && _vm.iconType === 'success'),
      expression: "novalidate && iconType === 'success'"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.novalidate && _vm.iconType === 'error'),
      expression: "novalidate && iconType === 'error'"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn"
    }
  }), _vm._v(" "), _vm._t("right"), _vm._v(" "), (_vm.hasRightFullHeightSlot) ? _c('div', {
    staticClass: "vux-x-input-right-full"
  }, [_vm._t("right-full-height")], 2) : _vm._e()], 2), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "width": "auto",
      "time": 600
    },
    model: {
      value: (_vm.showErrorToast),
      callback: function($$v) {
        _vm.showErrorToast = $$v
      },
      expression: "showErrorToast"
    }
  }, [_vm._v(_vm._s(_vm.firstError))])], 1)
},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": ("vux-popup-animate-" + _vm.position)
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && !_vm.initialShow),
      expression: "show && !initialShow"
    }],
    staticClass: "vux-popup-dialog",
    class: [("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],
    style: (_vm.styles)
  }, [(_vm.shouldRenderBody) ? _vm._t("default") : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-loading_toast vux-loading",
    class: !_vm.text ? 'vux-loading-no-text' : ''
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-toast",
    style: ({
      position: _vm.position
    })
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.text || '加载中')), _vm._t("default")], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-file-upload"
  }, [_c('ul', {
    staticClass: "img-group clear"
  }, [_c('file-upload', {
    ref: "upload",
    staticClass: "fl",
    attrs: {
      "name": _vm.name,
      "accept": "image/*",
      "multiple": _vm.multiple,
      "timeout": 600 * 1000,
      "headers": _vm.setHeader,
      "post-action": _vm.uploadUrl,
      "maximum": _vm.maxLength
    },
    on: {
      "input-file": _vm.inputFile,
      "input-filter": _vm.inputFilter
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  }, [(_vm.isEdit && _vm.multiple && _vm.files.length < _vm.maxLength) ? _c('div', {
    staticClass: "file-add fl"
  }, [_c('div', {
    staticClass: "vertical-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "horizontal1-line"
  })]) : (_vm.isEdit && !_vm.multiple && _vm.files.length < _vm.maxLength) ? _c('div', [_vm._v("点击上传")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.files), function(file, index) {
    return _c('li', {
      key: index,
      staticClass: "fl",
      class: _vm.getClassType.li
    }, [_c('img', {
      staticClass: "file-img previewer-demo-img",
      attrs: {
        "src": file.blob,
        "alt": _vm.getImgFileReallyName(file.name)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.preview(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "del-img",
      on: {
        "click": function($event) {
          return _vm.del(file, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      class: _vm.getClassType.delIcon
    })])])
  })], 2), _vm._v(" "), (_vm.isEdit && _vm.multiple && _vm.maxLength > 1) ? _c('div', {
    staticClass: "describe"
  }, [_vm._v("共选择了 " + _vm._s(_vm.files.length) + " 张图片，最多只能上传 " + _vm._s(_vm.maxLength) + " 图片")]) : (!_vm.isEdit && _vm.multiple && _vm.maxLength > 1) ? _c('div', {
    staticClass: "describe"
  }, [_vm._v("共 " + _vm._s(_vm.files.length) + " 张图片")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.files,
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "vux-label-desc"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-alert"
  }, [_c('x-dialog', {
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition,
      "hide-on-blur": _vm.hideOnBlur,
      "mask-z-index": _vm.maskZIndex
    },
    on: {
      "on-hide": function($event) {
        return _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        return _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", function() {
    return [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.content)
      }
    })]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onHide
    }
  }, [_vm._v(_vm._s(_vm.buttonText || '确定'))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-popup-header",
    class: _vm.showBottomBorder ? 'vux-1px-b' : ''
  }, [_c('div', {
    staticClass: "vux-popup-header-left",
    on: {
      "click": function($event) {
        return _vm.$emit('on-click-left')
      }
    }
  }, [_vm._t("left-text", function() {
    return [_vm._v(_vm._s(_vm.leftText))]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-popup-header-title"
  }, [_vm._t("title", function() {
    return [_vm._v(_vm._s(_vm.title))]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-popup-header-right",
    on: {
      "click": function($event) {
        return _vm.$emit('on-click-right')
      }
    }
  }, [_vm._t("right-text", function() {
    return [_vm._v(_vm._s(_vm.rightText))]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp vux-previewer",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "pswp__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__scroll-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pswp__ui pswp__ui--hidden"
  }, [_c('div', {
    staticClass: "pswp__top-bar"
  }, [_c('div', {
    staticClass: "pswp__counter"
  }), _vm._v(" "), _vm._t("button-after"), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--close",
    attrs: {
      "title": "Close (Esc)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--share",
    attrs: {
      "title": "Share"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--fs",
    attrs: {
      "title": "Toggle fullscreen"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--zoom",
    attrs: {
      "title": "Zoom in/out"
    }
  }), _vm._v(" "), _vm._t("button-before"), _vm._v(" "), _vm._m(1)], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--left",
    attrs: {
      "title": "Previous (arrow left)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--right",
    attrs: {
      "title": "Next (arrow right)"
    }
  }), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _vm._t("wrap-after")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp__container"
  }, [_c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp__preloader"
  }, [_c('div', {
    staticClass: "pswp__preloader__icn"
  }, [_c('div', {
    staticClass: "pswp__preloader__cut"
  }, [_c('div', {
    staticClass: "pswp__preloader__donut"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
  }, [_c('div', {
    staticClass: "pswp__share-tooltip"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp__caption"
  }, [_c('div', {
    staticClass: "pswp__caption__center"
  })])
}]}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    staticClass: "container"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-actionsheet"
  }, [_c('transition', {
    attrs: {
      "name": "vux-actionsheet-mask"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-mask weui-mask_transparent",
    on: {
      "click": _vm.onClickingMask
    }
  })]), _vm._v(" "), (_vm.theme === 'android') ? _c('div', {
    staticClass: "weui-skin_android"
  }, [_c('transition', {
    attrs: {
      "name": "vux-android-actionsheet"
    },
    on: {
      "after-enter": function($event) {
        return _vm.$emit('on-after-show')
      },
      "after-leave": function($event) {
        return _vm.$emit('on-after-hide')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-actionsheet"
  }, [_c('div', {
    staticClass: "weui-actionsheet__menu"
  }, _vm._l((_vm.menus), function(text, key) {
    return _c('div', {
      staticClass: "weui-actionsheet__cell",
      domProps: {
        "innerHTML": _vm._s(text.label || text)
      },
      on: {
        "click": function($event) {
          return _vm.onMenuClick(text, key)
        }
      }
    })
  }), 0)])])], 1) : _c('div', {
    ref: "iOSMenu",
    staticClass: "weui-actionsheet",
    class: {
      'weui-actionsheet_toggle': _vm.show
    }
  }, [_c('div', {
    staticClass: "weui-actionsheet__menu"
  }, [(_vm.hasHeaderSlot) ? _c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.menus), function(text, key) {
    return _c('div', {
      staticClass: "weui-actionsheet__cell",
      class: ("vux-actionsheet-menu-" + (text.type || 'default')),
      domProps: {
        "innerHTML": _vm._s(text.label || text)
      },
      on: {
        "click": function($event) {
          return _vm.onMenuClick(text, key)
        }
      }
    })
  })], 2), _vm._v(" "), (_vm.showCancel) ? _c('div', {
    staticClass: "weui-actionsheet__action",
    on: {
      "click": function($event) {
        return _vm.emitEvent('on-click-menu', 'cancel')
      }
    }
  }, [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_vm._v(_vm._s(_vm.cancelText || '取消'))])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-cell-box weui-cell",
    class: _vm.className,
    style: (_vm.style),
    on: {
      "click": _vm.onClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-flexbox-item",
    style: (_vm.style)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-checker-box"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "down-root"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "down-link",
    attrs: {
      "href": _vm.link
    },
    on: {
      "click": _vm.clickLink
    }
  }, [_vm._v("点击下载APP立即体验")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "success-tip"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(287),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("恭喜你注册成功")])])
}]}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell",
    class: {
      'vux-tap-active': _vm.isLink || !!_vm.link,
      'weui-cell_access': _vm.isLink || !!_vm.link,
      'vux-cell-no-border-intent': !_vm.borderIntent,
      'vux-cell-disabled': _vm.disabled
    },
    style: (_vm.style),
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-cell-bd",
    class: {
      'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'
    }
  }, [_c('p', [(_vm.title || _vm.hasTitleSlot) ? _c('label', {
    staticClass: "vux-label",
    class: _vm.labelClass,
    style: (_vm.labelStyles)
  }, [_vm._t("title", function() {
    return [_vm._v(_vm._s(_vm.title))]
  })], 2) : _vm._e(), _vm._v(" "), _vm._t("after-title")], 2), _vm._v(" "), _c('inline-desc', [_vm._t("inline-desc", function() {
    return [_vm._v(_vm._s(_vm.inlineDesc))]
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft",
    class: _vm.valueClass
  }, [_vm._t("value"), _vm._v(" "), _vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.value))]
  }), _vm._v(" "), (_vm.isLoading) ? _c('i', {
    staticClass: "weui-loading"
  }) : _vm._e()], 2), _vm._v(" "), _vm._t("child")], 2)
},staticRenderFns: []}

/***/ }),
/* 331 */,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(276)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(325),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(271)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(321),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(277)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(326),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(299),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(278)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(328),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(265)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(315),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(259)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(309),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(327),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(253)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(303),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(264)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(314),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(274)
  __webpack_require__(273)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(323),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(296),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(266)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(316),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(262)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(312),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-522ed26a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(279)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(329),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cd6577ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(247)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(297),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(252)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(302),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24e47ef4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(269)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(319),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(256)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(306),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(254)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(304),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })
]),[138]);


// WEBPACK FOOTER //
// static/js/app.2926989294aa8dabdc57.js